/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { formatProductUpdateErrorMessage } from './helpers/formatProductUpdateErrorMessage';
export const updateMasterProduct = createAsyncThunk(
  'products/updateMasterProduct',
  async ({ productId, data }, {
    extra: {
      sdk, Logger, Toast, utils,
    },
  }) => {
    try {
      const { data: updatedProduct } = await sdk.products.updateMasterProduct(productId, data);
      return { productId, updatedProduct };
    } catch (error) {
      const rawMessage = utils.getDataFromResponceError(error, 'msg');
      const errorMessage = rawMessage
        ? formatProductUpdateErrorMessage(rawMessage)
        : 'Cannot update master product';
      Toast(errorMessage, { type: 'error', autoClose: 5000 });
      Logger.error(new Error('Error updating master product'), { error }, [
        'UpdateMasterProductFailed',
        { errorMessage: rawMessage || errorMessage || 'NoMessage' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(updateMasterProduct.pending, (state) => {
      state.isBusy = true;
      state.error = null;
    })
    .addCase(updateMasterProduct.fulfilled, (state, { payload }) => {
      const { productId, updatedProduct } = payload;
      state.isBusy = false;
      state.items = state.items.map((item) => (
        item._id === productId ? { ...item, ...updatedProduct } : item
      ));
    })
    .addCase(updateMasterProduct.rejected, (state, { error }) => {
      state.isBusy = false;
      state.error = error?.message || 'Cannot update master product';
    });
};